import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=purchase&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '采购顾问',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美致力于为酒店客户提供从供应商筛选到采购预算审核的全流程采购解决方案，涵盖FF&E以及HOE等关键领域。许多酒店业主在采购过程中常面临供应商配合度低、预算超支等问题。华美依托成熟的供应商库和行业议价能力，确保客户以最具竞争力的价格获得高品质的采购成果。`,
        icons: [
            {
                name: '采购管理',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/4.采购顾问.pdf'),
                path: "四库赋能-酒店建设/采购顾问/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店建设/采购顾问/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/采购顾问/数据赋能'),
                path: "四库赋能-酒店建设/采购顾问/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/采购顾问/全球案例/全球案例（采购顾问）.xlsx'),
                path: "四库赋能-酒店建设/采购顾问/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/采购顾问/预警问题/预警问题（采购顾问）.xlsx'),
                path: "四库赋能-酒店建设/采购顾问/预警问题"
            },
        ]
    }]
}